import { render, staticRenderFns } from "./Finalize.vue?vue&type=template&id=b54cce90&scoped=true&lang=pug&"
import script from "./Finalize.vue?vue&type=script&lang=js&"
export * from "./Finalize.vue?vue&type=script&lang=js&"
import style0 from "./Finalize.vue?vue&type=style&index=0&id=b54cce90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54cce90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b54cce90')) {
      api.createRecord('b54cce90', component.options)
    } else {
      api.reload('b54cce90', component.options)
    }
    module.hot.accept("./Finalize.vue?vue&type=template&id=b54cce90&scoped=true&lang=pug&", function () {
      api.rerender('b54cce90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mobileFSFB/Finalize.vue"
export default component.exports